import styled from 'styled-components';

export default styled.div`
  .search-error {
    min-height: 10rem;
    text-align: center;
  }
`;
